import { Link, useNavigate, useParams } from "react-router-dom";
import { showMoneyShort } from "../Data/Money";
import { computeCharge, getNonEventRates } from "../Data/Rates";
import { Duration, LocalDateTime } from "@js-joda/core";
import { showDurationShort } from "../Data/Date";
import { PersonWalking } from "react-bootstrap-icons";
import { Button } from "./Button";
import { hourlyCheckoutAtom } from "../Data/Atoms";
import { useAtom } from "jotai";
import { Facility } from "../Data/ApiTypes";
import { facilityImg } from "../Data/Common";

export interface ResultHourlyEntryProps {
    facility:     Facility;
    onClick:      () => void;
    onRatesClick: () => void;
    className?:   string;
    start:        LocalDateTime;
    end:          LocalDateTime;
    walkingTime?: string;
}

export function ResultHourlyEntry( props: ResultHourlyEntryProps ) {
    const nav = useNavigate();
    const [hourlyCheckout, setHourlyCheckout] = useAtom( hourlyCheckoutAtom );
    const { name, hourlyRates, listImageId } = { ...props.facility };
    const { className = "", facility, start, end, walkingTime } = { ...props };

    const nonEventRates = getNonEventRates(hourlyRates);

    const lowestRate = computeCharge( nonEventRates, start, end);
    if (lowestRate.toJSON().amount == Number.MAX_SAFE_INTEGER) return; // this means there is no applicable rate available for this facility

    function viewRatesClick( e: React.MouseEvent<HTMLAnchorElement, MouseEvent> ) {
        e.stopPropagation();
        props.onRatesClick();
        return false;
    }

    function bookNowClick( e: React.MouseEvent<HTMLButtonElement, MouseEvent> ) {
        e.stopPropagation();
        setHourlyCheckout( { facility: facility, start: start, end: end, vehicles: [] })
        nav( "/checkout/hourly" );
        return false;
    }

    function detailsClick( e: React.MouseEvent<HTMLButtonElement, MouseEvent> ) {
        e.stopPropagation();
        props.onClick();
    }

    return <div className={`facility-result rounded-4 p-4 mb-3 shadow border border-2 ${className}`}
                onClick={ () => props.onClick() }>
        <div>
            <img className="facility-result-pic"
                 src={facilityImg( listImageId )}
                 style={{ aspectRatio: "1 / 1", objectFit: "cover" }} />
        </div>
        <div className="facility-result-info">
            <div className="grid-col-1">
                <div className="fw-bold">
                    {name}
                </div>
                {walkingTime && (
                    <div className="d-flex align-items-center small text-muted">
                        <PersonWalking />&thinsp;{walkingTime}
                    </div>
                )}
            </div>
            <div className="grid-col-2 text-end">
                <div className="fs-5 fw-bold">
                    {showMoneyShort(lowestRate)}+
                </div>
                <div style={{ fontSize: "0.75em" }} className="text-muted">
                    for {showDurationShort( Duration.between( start, end ) )}
                </div>
                <Link to="" style={{ fontSize: "0.75em" }} onClick={ viewRatesClick }>
                    See rates
                </Link>
            </div>
        </div>
        <div className="facility-result-bottom">
            <Button className="w-100" onClick={ detailsClick }>Details</Button>
            <Button className="w-100 btn-main" onClick={ bookNowClick }>
                Book
            </Button>
        </div>
    </div>;
}